 import { NewMediaManagerComponent } from './new-media-manager/new-media-manager.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, Route } from '@angular/router';
import { ListComponent } from './new-media-manager/list/list.component';


const routes: Routes = [

  {
    path: '',
    component: NewMediaManagerComponent,
    children: [
      {
        path: 'list',
        component: ListComponent
      },       
      { path: '', pathMatch: 'full' as Route['pathMatch'], redirectTo: 'list' }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NewMediaRoutingModule { }
